import tw, { styled } from 'twin.macro';

import { Props } from './Section';

type StyledSectionProps = Pick<Props, 'subdued'>;

export const StyledSection = styled.section<StyledSectionProps>(({ subdued }) => [subdued && tw`bg-gray-50`]);
